import { render } from "./ProfileMenu.vue?vue&type=template&id=3687e050&scoped=true&ts=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=ts"
export * from "./ProfileMenu.vue?vue&type=script&lang=ts"

import "./ProfileMenu.vue?vue&type=style&index=0&id=3687e050&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3687e050"]])

export default __exports__